class MiniCart extends HTMLElement {
  constructor() {
    super();

    //add event listeners
    this.addListeners();
    this.drawer = document.querySelector(".drawer--mini-cart");
    this.miniCartToggles = document.querySelectorAll(".js-mini-cart-toggle");
  }

  cartAddUnsubscriber = undefined;
  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartAddUnsubscriber = subscribe(PUB_SUB_EVENTS.cartAdd, () => {
      this.renderCart();
      if (!this.drawer.classList.contains("active")) {
        this.drawer.dispatchEvent(new Event("drawer-toggle"));
      }
    });

    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      this.renderCart();
    });
  }

  disconnectedCallback() {
    if (this.cartAddUnsubscriber) {
      this.cartAddUnsubscriber();
    }

    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  //quantity input change
  handleInputChange(input, key) {
    this.classList.add("loading");
    let lineKey = key;
    let quantity = 0;

    if (input && input.getAttribute("data-key")) {
      lineKey = input.getAttribute("data-key");
    }

    if (input && input.value) {
      quantity = parseInt(input.value);
    }

    if (lineKey && quantity >= 0) {
      const body = JSON.stringify({
        id: lineKey,
        quantity: quantity,
        sections: "mini-cart",
      });

      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((text) => {
          let sectionHtml = JSON.parse(text).sections["mini-cart"];
          this.renderCart(sectionHtml);
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      this.classList.remove("loading");
      console.error("No line item details");
    }
  }

  renderCart(html) {
    this.classList.add("loading");

    if (html) {
      //insert cart items
      this.querySelector(".js-mini-cart-items").innerHTML = html;

      this.postRenderFunctions();
    } else {
      fetch("/?section_id=mini-cart-items")
        .then((response) => {
          return response.text();
        })
        .then((response) => {
          //insert cart items
          this.querySelector(".js-mini-cart-items").innerHTML = response;

          this.postRenderFunctions();
        });
    }
  }

  postRenderFunctions() {
    //add event listeners
    this.addListeners();

    //update total
    this.updateTotal();

    this.classList.remove("loading");
  }

  addListeners() {
    //get form elements and add event listeners
    this.miniCartForm = this.querySelector("form");
    if (this.miniCartForm) {
      this.quantityInputs = this.miniCartForm.querySelectorAll(
        ".js-mini-cart-quantity"
      );
      this.removeButtons = this.miniCartForm.querySelectorAll(
        "mini-cart-remove-button"
      );
      if (this.quantityInputs) {
        this.quantityInputs.forEach((input) =>
          input.addEventListener(
            "change",
            this.handleInputChange.bind(this, input)
          )
        );
      }

      if (this.removeButtons) {
        this.removeButtons.forEach((input) =>
          input.addEventListener("click", (e) => {
            e.preventDefault();
            this.handleInputChange(null, input.getAttribute("data-key"));
          })
        );
      }
    }
  }

  updateTotal() {
    //updates cart total
    const totalElements = document.querySelectorAll(".js-mini-cart-total");
    const countElements = document.querySelectorAll(".js-cart-count, .js-cart-count-mini-cart");
    const cartTotal = document.getElementById("cart-total-hidden");

    if (totalElements && cartTotal) {
      const countTotal = cartTotal.getAttribute("data-cart-quantity");

      totalElements.forEach((el) => {
        el.innerHTML = cartTotal.innerHTML;
      });

      if (this.miniCartToggles.length) {
        this.miniCartToggles.forEach((el) => {
          if (parseInt(countTotal) > 0) {
            el.classList.add("has-items");
          } else {
            el.classList.remove("has-items");
          }
        });
      }

      if (countElements.length) {
        countElements.forEach((el) => {
          el.innerHTML = countTotal;
        });
      }
    }
  }
}

customElements.define("mini-cart", MiniCart);
